import React, { useRef, useEffect, useState } from "react";
import withToolTip from "./withToolTip";
import "../Styles/Pages/tooltip.scss";
import { _isInViewPort } from "../Utils/helpers";

function ToolTip(props) {
	const isDefaultTopPosition = props.position === "top";
	const messageRef = useRef(null);
	const toolTipRef = useRef(null);
	const [showOnTop, setShowOnTop] = useState("");
	const [top, setTop] = useState("");
	const [animTooltip, setAnimTooltip] = useState("");

	useEffect(() => {
		if (props.hovering) {
			if (messageRef.current) {
				setShowOnTop(
					isDefaultTopPosition
						? "show__ontop"
						: _isInViewPort(messageRef.current)
						? ""
						: "show__ontop",
				);
				const tooltipHeight = messageRef.current.offsetHeight || 100;
				setTop(
					_isInViewPort(messageRef.current) && !isDefaultTopPosition
						? ""
						: `${0 - (15 + tooltipHeight)}px`,
				);

				setTimeout(() => {
					setAnimTooltip("anim-tooltip");
				}, 50);
			} else {
				if (!isDefaultTopPosition) {
					setShowOnTop("");
				}
				setTop("");
			}
		} else {
			if (!isDefaultTopPosition) {
				setShowOnTop("");
			}

			setTop("");
			setAnimTooltip("");
		}
	}, [props.hovering]);

	useEffect(() => {
		if (toolTipRef.current && props.adjustParentStyle) {
			if (toolTipRef.current.parentNode && toolTipRef.current.parentNode) {
				let parentContainer = toolTipRef.current.parentNode.parentNode;
				parentContainer.style.display = "inline-flex";
				parentContainer.style.position = "relative";
				toolTipRef.current.style.right = "-20px";
				toolTipRef.current.style.top = "calc(50% + 0px)";
			}
		}
		let allToolTipsOnPage = document.querySelectorAll(".tooltip__component");
		Array.from(allToolTipsOnPage).forEach((element, i) => {
			element.style.zIndex = props.ZIndex || allToolTipsOnPage.length + 5 - i;
		});
	}, []);

	return (
		<div
			className="tooltip__component"
			style={{
				zIndex: props.ZIndex
					? showOnTop
						? props.ZIndex + 2
						: props.ZIndex
					: "",
			}}
			ref={toolTipRef}
		>
			{props.icon ? (
				<div dangerouslySetInnerHTML={{ __html: props.icon }} />
			) : (
				<svg
					viewBox="0 0 512 512"
					style={{
						opacity: props.hideIcon ? 0 : 0.5,
						visibility: props.hideIcon ? "hidden" : "",
					}}
					height={"13px"}
					width={props.hideIcon ? "40px" : "13px"}
				>
					<circle cx={256} cy={378.5} r={25} fill={"#232f49"} />
					<path
						fill={"#232f49"}
						d="M256 0C114.516 0 0 114.497 0 256c0 141.484 114.497 256 256 256 141.484 0 256-114.497 256-256C512 114.516 397.503 0 256 0zm0 472c-119.377 0-216-96.607-216-216 0-119.377 96.607-216 216-216 119.377 0 216 96.607 216 216 0 119.377-96.607 216-216 216z"
					/>
					<path
						fill={"#232f49"}
						d="M256 128.5c-44.112 0-80 35.888-80 80 0 11.046 8.954 20 20 20s20-8.954 20-20c0-22.056 17.944-40 40-40s40 17.944 40 40-17.944 40-40 40c-11.046 0-20 8.954-20 20v50c0 11.046 8.954 20 20 20s20-8.954 20-20v-32.531c34.466-8.903 60-40.26 60-77.469 0-44.112-35.888-80-80-80z"
					/>
				</svg>
			)}

			{props.hovering && (
				<div
					className={`tooltip__component__msg ${animTooltip} ${showOnTop}`}
					role="tooltip"
					style={{
						width: props.width ? `${props.width}px` : "150px",
						top: top,
					}}
					ref={messageRef}
				>
					{props.children}
					<div className="tooltip__component__msg__arrow" />
				</div>
			)}
		</div>
	);
}
export default withToolTip(ToolTip);
